import styled from '@emotion/styled'
import { fontSize, size } from '@styles/theme'

const PostNotFoundContainer = styled.div`
  padding-bottom: ${size(2)};
  height: ${size(20)};
`

const PostNotFoundBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  background-color: #141414;
  color: #333333;
  text-align: center;
  font-weight: 600;
  font-size: ${fontSize('lg')};
  height: 100%;
`

const PostNotFoundMessage = ({ post }) => {
  if (!post?.uuid) return (
    <PostNotFoundContainer>
      <PostNotFoundBody>
        Post Not Found
      </PostNotFoundBody>
    </PostNotFoundContainer>
  )
}

export { PostNotFoundMessage }
